import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/oneteg-new-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-48c459c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-bg" }, null, -1))
const _hoisted_2 = { class: "resetPassword" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-section height-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "d-flex justify-content-center align-content-center flex-column height-90" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-center align-content-center flex-column"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description" }, " Scan the QR code below with your authenticator app to finish the setup ", -1))

import { onMounted, ref, watch, watchEffect } from "vue";
import { ElButton, ElForm, ElFormItem, ElInput } from "element-plus";
import { router, currentRoute } from "@/core/router";
import { changeLocale } from "@/core/i18n";
import i18n from "@/core/i18n/i18n";
import { otpSetupRetrieveKey, otpSetupValidate } from "@/core/auth/auth";
import QrcodeVue from "qrcode.vue";
import { showAlert } from "@/core/popup";
import { TYPE } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'OtpSetup',
  setup(__props) {

const { t } = i18n.global;

const loading = ref(false);

const formOtpCode = ref({
  otpCode: "",
});

const formRules = ref({
  otpCode: [
    {
      required: true,
      message: "Please input email",
      trigger: "blur",
    },
  ],
});

const validValue = ref(false);

const elForm = ref<InstanceType<typeof ElForm>>();

onMounted(() => {
  watch(
    () => [formOtpCode.value.otpCode],
    () => {
      elForm.value.validate((valid) => {
        validValue.value = valid;
      });
    }
  );
  (async () => {
    const response = await otpSetupRetrieveKey();

    if (response.code === 200) {
      const otp = response.result;
      otpUrl.value = `otpauth://totp/${encodeURIComponent(
        otp.issuer
      )}:${encodeURIComponent(otp.username)}?secret=${
        otp.key
      }&issuer=${encodeURIComponent(otp.issuer)}`;
    } else if (response.code === 403) {
      await router.push("otp-authenticate");
    } else if (response.code === 405) {
      await router.push("dashboard");
    } else {
      showAlert("error", response.message);
    }
  })();
});

const otpUrl = ref("");

const handleOtpAuthenticate = async () => {
  if (loading.value) return;
  loading.value = true;
  const isSuccess = await otpSetupValidate(formOtpCode.value.otpCode);
  if (isSuccess) {
    await router.push("otp-authenticate");
    showAlert(
      TYPE.SUCCESS,
      "Your verification code has been set up successfully."
    );
  }
  loading.value = false;
};

const selectedLocale = ref(currentRoute.value.params.locale as string);
watchEffect(() => changeLocale(selectedLocale.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (otpUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(ElForm), {
                ref_key: "elForm",
                ref: elForm,
                model: formOtpCode.value,
                rules: formRules.value,
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  (otpUrl.value)
                    ? (_openBlock(), _createBlock(_unref(ElFormItem), {
                        key: 0,
                        class: "d-flex flex-column align-items-center justify-content-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(QrcodeVue, {
                            value: otpUrl.value,
                            size: 160
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(ElFormItem), {
                    class: "d-flex flex-column align-items-center justify-content-center",
                    prop: "otpCode",
                    label: _unref(t)('Common.OtpCode')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formOtpCode.value.otpCode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formOtpCode.value.otpCode) = $event)),
                        class: "min-width",
                        onKeydown: _withKeys(_withModifiers(handleOtpAuthenticate, ["prevent"]), ["enter"])
                      }, null, 8, ["modelValue", "onKeydown"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_unref(ElFormItem), { class: "d-flex flex-column align-items-center justify-content-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElButton), {
                        disabled: !validValue.value,
                        loading: loading.value,
                        class: "btn-primary submit-button",
                        "native-type": "button",
                        size: "large",
                        onClick: handleOtpAuthenticate
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("Common.OtpValidate")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})